import React from "react";
import Routers from "./router";

const App = () => {
	return <Routers />;
};

export default App;
